module.exports = "<baf-about-view></baf-about-view>\n<baf-user-profile-view></baf-user-profile-view>\n<baf-cert-view></baf-cert-view>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/dialogs.component.html
// module id = ./src/app/components/dialogs/dialogs.component.html
// module chunks = main